import { render, staticRenderFns } from "./tabTexts.vue?vue&type=template&id=4244fdbb&scoped=true"
import script from "./tabTexts.vue?vue&type=script&lang=js"
export * from "./tabTexts.vue?vue&type=script&lang=js"
import style0 from "./tabTexts.vue?vue&type=style&index=0&id=4244fdbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4244fdbb",
  null
  
)

export default component.exports